import { UpperCasePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import {
  ONYX_TABLE_TOOLTIP_DELAY,
  OnyxIconComponent,
  OnyxTooltipDirective,
} from '@onyx/angular';

@Component({
  selector: 'app-order-ftl-cell',
  imports: [OnyxIconComponent, OnyxTooltipDirective, UpperCasePipe],
  templateUrl: './order-ftl-cell.component.html',
  styleUrl: './order-ftl-cell.component.scss',
})
export class OrderFtlCellComponent {
  public readonly isDedicated = input.required<boolean>();

  protected readonly TOOLTIP_DELAY = ONYX_TABLE_TOOLTIP_DELAY;
}
